export enum SearchResultVariant {
	Recent = 'RECENT',
	Suggestion = 'SUGGESTION',
	Task = 'TASK',
	Project = 'PROJECT',
	ProjectGroup = 'PROJECT_GROUP',
	InternalTime = 'INTERNAL_TIME',
}
